import React, { useState } from 'react';
import axios from 'axios';
import { CircularProgress } from '@material-ui/core';
import './AudioUpload.css';

function AudioUpload({ bookId, onUploadSuccess, canUpload = false }) {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const API_URL = process.env.REACT_APP_API_URL;

    if (!canUpload) {
        return null;
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type.startsWith('audio/')) {
            setFile(selectedFile);
            setError('');
            setSuccess('');
        } else {
            setFile(null);
            setError('Please select a valid audio file (MP3, WAV, AAC, etc.)');
            setSuccess('');
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Please select a file first');
            return;
        }

        setLoading(true);
        setError('');
        setSuccess('');
        const formData = new FormData();
        formData.append('audio', file);
        formData.append('isAdmin', true);

        try {
            const response = await axios.post(
                `${API_URL}api/books/uploadaudio/${bookId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.status === 200) {
                setFile(null);
                setSuccess('Audio uploaded successfully');
                if (onUploadSuccess) {
                    onUploadSuccess(response.data.audioUrl);
                }
            }
        } catch (err) {
            setError(err.response?.data || 'Error uploading audio');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="audio-upload-container">
            <div className="audio-upload-header">
                <h4>Upload Audio Book</h4>
                <p>Supported formats: MP3, WAV, AAC, OGG</p>
            </div>

            <div className="audio-upload-content">
                <input
                    type="file"
                    accept="audio/*"
                    onChange={handleFileChange}
                    className="audio-file-input"
                    id="audio-upload"
                />
                <label htmlFor="audio-upload" className="audio-upload-label">
                    {file ? file.name : 'Choose audio file'}
                </label>

                <button
                    onClick={handleUpload}
                    disabled={!file || loading}
                    className="audio-upload-button"
                >
                    {loading ? <CircularProgress size={24} /> : 'Upload Audio'}
                </button>
            </div>

            {error && <div className="audio-upload-error">{error}</div>}
            {success && <div className="audio-upload-success">{success}</div>}
        </div>
    );
}

export default AudioUpload;

